import React, { useState, useEffect } from 'react';
// تم تصحيح ShieldCheck هنا (حذف المسافة)
import { User, Mail, Lock, ShieldCheck, Save, AlertCircle } from 'lucide-react';
import axios from 'axios';

const Profile = () => {
  // جلب البيانات مع التأكد من وجود كائن افتراضي لتجنب أخطاء القراءة
  const adminData = JSON.parse(localStorage.getItem('adminUser')) || { id: 1, username: '', email: '' };
  
  const [formData, setFormData] = useState({
    id: adminData.id,
    username: adminData.username,
    email: adminData.email || '',
    password: ''
  });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.put('https://my-pharmacy-api.onrender.com/api/admin/update', formData);
      setMessage(res.data.message);
      
      // تحديث البيانات في الذاكرة المحلية لكي يتحدث الاسم في القائمة الجانبية فوراً
      const updatedUser = { ...adminData, username: formData.username, email: formData.email };
      localStorage.setItem('adminUser', JSON.stringify(updatedUser));
      
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      alert("عذراً، فشل تحديث البيانات. تأكدي من اتصال السيرفر.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-8" dir="rtl">
      <div className="bg-white dark:bg-slate-900 p-8 rounded-[40px] shadow-sm border border-gray-50 dark:border-slate-800 transition-all">
        <div className="flex items-center gap-4 mb-8">
          <div className="p-4 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-3xl">
            <ShieldCheck size={32} />
          </div>
          <div>
            <h2 className="text-2xl font-black text-gray-800 dark:text-white">إعدادات الحساب</h2>
            <p className="text-gray-400 font-bold text-sm">تحديث بيانات الإدارة والأمان</p>
          </div>
        </div>

        <form onSubmit={handleUpdate} className="space-y-6">
          {/* حقل اسم المستخدم */}
          <div className="space-y-2">
            <label className="text-sm font-black text-gray-700 dark:text-gray-300 flex items-center gap-2 mr-2">
              <User size={16} /> اسم المستخدم
            </label>
            <input 
              required
              type="text" 
              className="w-full bg-gray-50 dark:bg-slate-800 border-2 border-transparent focus:border-blue-500 rounded-2xl py-4 px-6 font-bold dark:text-white transition-all outline-none"
              value={formData.username}
              onChange={(e) => setFormData({...formData, username: e.target.value})}
            />
          </div>

          {/* حقل البريد */}
          <div className="space-y-2">
            <label className="text-sm font-black text-gray-700 dark:text-gray-300 flex items-center gap-2 mr-2">
              <Mail size={16} /> البريد الإلكتروني
            </label>
            <input 
              required
              type="email" 
              className="w-full bg-gray-50 dark:bg-slate-800 border-2 border-transparent focus:border-blue-500 rounded-2xl py-4 px-6 font-bold dark:text-white transition-all outline-none"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
            />
          </div>

          {/* حقل كلمة المرور */}
          <div className="space-y-2">
            <label className="text-sm font-black text-gray-700 dark:text-gray-300 flex items-center gap-2 mr-2">
              <Lock size={16} /> كلمة المرور الجديدة
            </label>
            <input 
              type="password" 
              placeholder="اتركها فارغة للحفاظ على الحالية"
              className="w-full bg-gray-50 dark:bg-slate-800 border-2 border-transparent focus:border-blue-500 rounded-2xl py-4 px-6 font-bold dark:text-white transition-all outline-none"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
            />
          </div>

          {message && (
            <div className="flex items-center gap-2 text-green-600 bg-green-50 dark:bg-green-900/20 p-4 rounded-2xl font-bold animate-pulse">
              <AlertCircle size={20} /> {message}
            </div>
          )}

          <button 
            type="submit"
            disabled={loading}
            className={`w-full py-5 rounded-[25px] font-black flex items-center justify-center gap-3 transition-all shadow-xl active:scale-95 ${
              loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700 text-white shadow-blue-100 dark:shadow-none'
            }`}
          >
            {loading ? 'جاري الحفظ...' : <><Save size={20} /> حفظ التغييرات</>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profile;